module.exports = __webpack_public_path__ + "media/images/lb/588-8d24e1bc6fab7d97519a5a55fe2e2ee6.svg";